export const IMPORT_UNITS_XLS_TEMPLATE_NAME = 'template.xlsx';
export const IMPORT_UNITS_GOOGLE_DRIVE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1-iw_l7395srbMxCjs5oG-J4mW30RJ7Pfa9f7VG5duuw/edit';
export const IMPORT_NON_AES_UNITS_GOOGLE_DRIVE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1HU-LM1NzkVegHdLaSHGYsGhUmbMtrEH_j8GodY73dX8/edit';
export const IMPORT_FACP_ZONE_CONFIGURATION_GOOGLE_DRIVE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1wcffPErHe1TgCVCHW2kuuGqgPK-O-Y-sg8IXo3_xpNY/edit?usp=sharing';
export const IMPORT_CUSTOMER_TEMPLATE =
  'https://docs.google.com/spreadsheets/d/1xl6vdi87Qp1jt_sH3fJwhEBHuiMjxT7JzupNtIiRUAE/edit?pli=1&gid=0#gid=0';

